import { State } from "./State";
export class Player {
    constructor(eventsChannelFactory, id, identityOverride, name, pictureId, roomId) {
        this.eventsChannelFactory = eventsChannelFactory;
        this.id = id;
        this.identityOverride = new State(identityOverride);
        this.name = new State(name);
        this.pictureId = new State(pictureId);
        this.roomId = new State(roomId);
    }
    getEventsChannel() {
        return this.eventsChannelFactory.createEventsChannel(`player.${this.id}`);
    }
}
